import { useMsal } from '@azure/msal-react';
import { Box, Typography } from '@mui/material';
import { useContext, useState } from 'react';
import { Order_By } from '../../models/GQLGeneratedModels';
import { getBugReportId } from '../../services/SaveLoadSearchService';
import { ApplicationContext } from '../ApplicationProvider';
import { ConfigitContext } from '../ConfigitProvider';
import { ButtonComponent } from '../shared/ButtonComponent/ButtonComponent';
import { Dialog } from '../shared/DialogComponent/Dialog';
import { SelectComponent } from '../shared/SelectComponent/SelectComponent';
import TextAreaComponent from '../shared/TextAreaComponent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ReportBug = function () {
    var azureADPCA = useMsal().instance;
    var _a = useContext(ApplicationContext), itemOffset = _a.itemOffset, itemsPerPage = _a.itemsPerPage, filters = _a.filters;
    var _b = useContext(ConfigitContext), layers = _b.layers, variableAssignments = _b.variableAssignments, manufacturerProduct = _b.manufacturerProduct, excludedLayerIds = _b.excludedLayerIds;
    var _c = useContext(ApplicationContext), setDialog = _c.setDialog, setShowDialog = _c.setShowDialog;
    var _d = useState(''), reason = _d[0], setReason = _d[1];
    var _e = useState(''), notes = _e[0], setNotes = _e[1];
    var _f = useState(false), selectError = _f[0], setSelectError = _f[1];
    var _g = useState(false), textError = _g[0], setTextError = _g[1];
    var reasonOptions = [{ name: 'Zero results', value: 1 }, { name: 'Inconsistent result', value: 2 }, { name: 'Other', value: 3 }];
    var getReasonOptionTextBasedOnValue = function (value) { if (value === '')
        return '';
    else {
        for (var i = 0; i < reasonOptions.length; i++) {
            if (reasonOptions[i].value.toString() === value)
                return reasonOptions[i].name;
        }
        return '';
    } };
    var handleSendClick = function () {
        setSelectError(false);
        setTextError(false);
        if (reason === '') {
            setSelectError(true);
        }
        if (notes === '') {
            setTextError(true);
        }
        if (notes !== '' && reason !== '') {
            var _azureADPCA$getActive, _azureADPCA$getActive2; // Temporarily comments out the functionality of posting report bug into DB
            // Get user email
            var userEmail = ((_azureADPCA$getActive = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive === void 0 ? void 0 : _azureADPCA$getActive.username) || 'test@test.com'; // works for initial Azure B2C before customization
            // For customized Azure B2C, user email needs to be retrieved as follows:
            var tokenClaims = void 0;
            if ((_azureADPCA$getActive2 = azureADPCA.getActiveAccount()) !== null && _azureADPCA$getActive2 !== void 0 && _azureADPCA$getActive2.idTokenClaims) {
                var _azureADPCA$getActive3;
                tokenClaims = (_azureADPCA$getActive3 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive3 === void 0 ? void 0 : _azureADPCA$getActive3.idTokenClaims;
                if (tokenClaims && tokenClaims.hasOwnProperty('email')) {
                    userEmail = tokenClaims['email'];
                }
            } //const userName = azureADPCA.getActiveAccount()?.name || 'test user';
            var reasonText = getReasonOptionTextBasedOnValue(reason);
            var urlPath = window.location.href; // Add a bug report into database
            getBugReportId(layers, //filters,
            variableAssignments, excludedLayerIds, manufacturerProduct, itemsPerPage, itemOffset, { AssemblyId: Order_By.Asc, CoverSubassemblyId: Order_By.Asc, DeckSubassemblyId: Order_By.Asc }, reasonText, notes, userEmail, urlPath); // console.log('Reason is ', reason);
            // console.log('reasonText is ', reasonText);
            // console.log('Notes is ', notes);
            setDialog(/*#__PURE__*/ _jsx(Dialog, { label: "Thank You", children: /*#__PURE__*/ _jsxs(Box, { gap: 2, display: "flex", flexDirection: "column", children: [/*#__PURE__*/ _jsx(Typography, { className: 'py-2', fontFamily: 'Inter', fontSize: '16px', lineHeight: '20px', children: "Thank you, your message has been sent to our team for review." }), /*#__PURE__*/ _jsx(ButtonComponent, { buttonType: "primary", buttonText: "Close", buttonCss: { margin: 0 }, click: function () { return setShowDialog(false); } })] }) }));
            setShowDialog(true);
        }
    };
    return /*#__PURE__*/ _jsxs(Box, { gap: 2, display: "flex", flexDirection: "column", children: [/*#__PURE__*/ _jsx(Typography, { className: 'py-2', fontFamily: 'Inter', fontSize: '16px', lineHeight: '20px', children: "Your search criteria will automatically be sent, please add additional details below." }), /*#__PURE__*/ _jsx(SelectComponent, { label: "Reason", options: reasonOptions, required: true, className: 'as-2', value: reason, setValue: setReason, isError: selectError, errorMsg: "Please select an option" }), /*#__PURE__*/ _jsx(TextAreaComponent, { label: "Describe the error you encountered:", required: true, value: notes, setValue: setNotes, isError: textError, errorMsg: "Please enter a short description of the error" }), /*#__PURE__*/ _jsx(ButtonComponent, { buttonType: "primary", buttonText: "Send", click: handleSendClick })] });
};
export default ReportBug;
